export default __webpack_public_path__ + "img/bLJBZwLL.f12b0eb6.svg";